module.exports = __webpack_public_path__ + "static/media/connect-icon-inactive.bbc1c0e0.svg";